
import BaseMixin from '@/views/mixin.vue'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design';
import compSearch from './search';
import compDetail from './detail';
import { HttpAllotList, HttpUpdateAllotStatus, HttpResendAllot } from '@/service/allotment/transfer';
import comAddnotes from '../../amazonallot/cancel'
import comUpdate from './update'
export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        comAddnotes,
        comUpdate
    },
    data () {
        return {
            statuslist: {
                establish: '已创建',
                confirm: '已确认',
                outdept: '出库中',
                complete: '已完成',
                close: '已取消',
            }
        };
    },
    methods: {
        httpList: HttpAllotList,
        handleOperate (id, type) {
            this.operate = {};
            switch (type) {
                case 'confirm':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: '确认操作',
                        type,
                        status: 1
                    }
                    break;
                case 'cancel':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning('请选择至少一条数据');
                        return;
                    }
                    // this.showDel = true;
                    this.operate = {
                        show: true,
                        title: '取消操作',
                        width: 600,
                        component: "comAddnotes",
                        activeids: this.checkedId,
                        status: 4
                    }
                    break;
                case 'complete':
                    this.showDel = true;
                    this.operate = {
                        title: '完成操作',
                        type,
                        status: 3,
                        id,
                    }
                    break;
                case 'repeat':
                    this.showDel = true;
                    this.operate = {
                        title: '重送操作',
                        type,
                        id,
                    }
                    break;
                case 'query':
                    this.operate = {
                        show: true,
                        width: 1200,
                        title: '查看',
                        component: "comUpdate",
                        activeids: id,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'queryBlank':
                    var url = this.$router.resolve({
                        name: 'tsUpdate',
                        params: { type: "query" },
                        query: { id }
                    });
                    window.open(url.href, '_blank');

                    // this.$router.push({
                    //     name: 'tsUpdate',
                    //     params: { type },
                    //     query: { id }
                    // });
                    break;
                case 'add':
                    this.$router.push({
                        name: 'tsUpdate',
                        params: { type }
                    });
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'tsUpdate',
                        params: { type },
                        query: id
                    });
                    break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/AmazonAllocation/importItems",
                        name: "excelFile",
                        component: "compUpload",
                        showdownload: true,
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/AmazonAllocation/excel', {}, 'download')
                        },
                        refresh: this.updateList,
                        on: {
                            'on-success': (res) => {
                                this.$VModal.destroy();
                            },
                        }
                    }
                    break;
            }
        },
        async batchOpearte () {
            let request = HttpUpdateAllotStatus, { type, status, id } = this.operate, params = { ids: this.checkedId.join(','), status };
            switch (type) {
                case 'confirm': break;
                case 'cancel': break;
                case 'complete': params = { status, ids: id }; break;
                case 'repeat': request = HttpResendAllot; params = { id }; break;
                default: request = function () { }; break;
            }
            request(params).then(res => {
                this.updateList();
                this.$Message.success(res.message);
                this.showDel = false;
            }).catch(err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                this.showDel = false;
                this.operate = {};
            })
        },

    },
    computed: {

        columns () {
            return [
                {
                    type: 'selection',
                    width: 60,
                },
                {
                    title: "操作",
                    width: 90,
                    render: (h, { row }) => {
                        const id = row.id, status = row.orderStatus;
                        return <Dropdown placement="bottom-start" trigger="click">
                            <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                            <DropdownMenu slot="list" class="text-left">
                                <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query')}>查看</DropdownItem>
                                <DropdownItem class='splitline' v-show={status === 'outdept' || status === 'establish' || status === 'confirm'} nativeOnClick={this.handleOperate.bind(this, { status, id }, 'edit')}>编辑</DropdownItem>
                                <DropdownItem class='splitline' v-show={status === 'establish'} nativeOnClick={this.handleOperate.bind(this, id, 'confirm')}>确认</DropdownItem>

                                <DropdownItem class='splitline' v-show={status === 'outdept' && row.version == 1} nativeOnClick={this.handleOperate.bind(this, id, 'repeat')}>重送</DropdownItem>
                                <DropdownItem v-show={status === 'outdept' || status === 'establish' || status === 'confirm'} nativeOnClick={this.handleOperate.bind(this, id, 'cancel')}>取消</DropdownItem>
                            </DropdownMenu>
                        </Dropdown >
                    }
                },
                {
                    title: '移库计划单号',
                    key: 'tranNo',
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperate.bind(this, row.id, 'query')}>{row.tranNo}</a>
                            <a onClick={this.handleOperate.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        // <a onClick={this.handleOperate.bind(this, row.id, 'query')}>{row.tranNo}</a>
                    }
                },
                {
                    title: '项目',
                    key: 'lineId',
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.products.filter((item) => {
                            return id == item.id
                        })[0] || {};
                        return <span>{product.name}</span>
                    },
                },
                {
                    title: '调出仓库',
                    key: 'orgWareName',
                }, {
                    title: '接收仓库',
                    key: 'srcOrgWareName',
                    render (h, { row }) {
                        return <span>{row.srcOrgWareName || 'Others'}</span>
                    }
                }, {
                    title: 'Remove Order ID',
                    key: 'removeOrderId',
                }, {
                    title: 'Seller SKU',
                    key: 'sellerSkus',
                    render (h, { row }) {
                        let inboundAmount = 0, shippingNum = 0;
                        row.allocationItems.forEach(item => {
                            inboundAmount += item.inboundAmount
                            shippingNum += item.shippingNum
                        });
                        return <div>
                            {row.sellerSkus}<br />
                            发运数量:{shippingNum}<br />
                            接收数量:{inboundAmount}<br />
                        </div>
                    }
                }, {
                    title: '单据状态',
                    key: 'orderStatus',
                    render: (h, { row }) => {
                        return <span>{this.statuslist[row.orderStatus]}</span>
                    }
                }, {
                    title: '创建日期',
                    key: 'orderDate',
                    sortable: true,
                },
            ];
        },
    },
};




